<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl five-per-row" label="操作类型" prop="operateType">
        <el-select-dict dictType="INVENTORY_TYPE" clearable v-model.trim="queryParams.operateType" placeholder="请选择操作类型"
          @dictChange="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="仓库" prop="wareHouseId">
        <el-cascader aria-hidden="false" :options="wareHouseData" @change="handleQuery" clearable :props="defaultProps"
          v-model="wareHouseId" placeholder="请选择仓库" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="操作单号" prop="operateNo">
        <el-input v-model.trim="queryParams.operateNo" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入操作单号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品名称" prop="goodsName">
        <el-input v-model.trim="queryParams.goodsName" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品名称" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="商品编号" prop="goodsSn">
        <el-input v-model.trim="queryParams.goodsSn" clearable @keyup.enter.native="handleQuery"
          placeholder="请输入商品编号" />
      </el-form-item>
      <el-form-item class="search-field fl five-per-row" label="单品编号" prop="spuSn">
        <el-input v-model.trim="queryParams.spuSn" clearable @keyup.enter.native="handleQuery" placeholder="请输入单品编号" />
      </el-form-item>

      <el-form-item class="search-field fl five-per-row" label="生产日期">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="search-field fl five-per-row" label="操作日期">
        <el-date-picker v-model="dateRange2" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
      </div>
      <div class="table-box">
        <auto-height-table instanceHeight="238" :key="queryParams.dimension" ref="recordTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
          v-loading="loading" :data="list">
          <el-table-column label="操作单号" prop="operateNo" align="center" width="172px">
            <template slot-scope="scope">
              <el-link v-if="hasPermission(scope.row.operateType)" type="primary" @click="handleDetail(scope.row)">{{ scope.row.operateNo
                }}</el-link>
              <span v-else>{{ scope.row.operateNo }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="queryParams.dimension === 'wareHouseId'" label="仓库" prop="wareHouseName" align="center"
            min-width="156px">
            <template slot-scope="scope">
              {{ getWareHouseName(scope.row.wareHouseId) }}
            </template>
          </el-table-column>
          <el-table-column label="商品信息" prop="goodsName" align="left" min-width="300px">
            <template slot-scope="scope">
              <div class="goods-info flex-c-s">
                <div class="goods-info-left">
                  <img @click.stop="mixinHandlePreview(scope.row.goodsImgs && scope.row.goodsImgs.split(','))"
                    :src="mixinGetImg(scope.row.goodsImgs && scope.row.goodsImgs.split(',')[0])" width="40px" height="40px"
                    alt="商品图片">
                </div>
                <div class="goods-info-right flex-c-c flex-col">
                  <div class="top">
                    <span class="label">名称：</span>
                    <span class="value">{{ scope.row.goodsName }}</span>
                  </div>
                  <div class="bottom">
                    <span class="label">编号：</span>
                    <span class="value">{{ scope.row.goodsSn }}</span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="规格信息" prop="skuListStr" align="left" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info-right flex-c-c flex-col">
                <div class="top">
                  <span class="label">规格：</span>
                  <span class="value">{{ scope.row.skuListStr }}</span>
                </div>
                <div class="bottom">
                  <span class="label">编号：</span>
                  <span class="value">{{ scope.row.spuSn }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column-dict label="操作类型" dictTypeNode="tag" prop="operateType" dictType="INVENTORY_TYPE"
            align="center" min-width="96px" />
          <el-table-column label="仓库" prop="wareHouseName" align="center" min-width="156px">
            <template slot-scope="scope">
              {{ getWareHouseName(scope.row.wareHouseId) }}
            </template>
          </el-table-column>
          <el-table-column label="生产日期" prop="manufactureDate" align="center" min-width="128px" />
          <el-table-column label="成本单价(元)" prop="costPrice" align="center" min-width="128px" />
          <el-table-column label="操作前库存" prop="spuNumber" align="center" min-width="96px" />
          <el-table-column label="操作后库存" prop="newSpuNumber" align="center" min-width="96px" />
          <el-table-column dateFormat="datetime" label="数量" align="center" prop="createTime" min-width="118px">
            <template slot-scope="scope">
              <div class="flex-c-b">
                <span>数量：</span>
                <span>{{ scope.row.profitLossNumber | numberFilter }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="channel"
            min-width="100px"></el-table-column-dict>
          <el-table-column dateFormat="datetime" label="操作信息" align="left" prop="createTime" min-width="256px">
            <template slot-scope="scope">
              <div class="goods-info-right flex-c-c flex-col">
                <div class="top">
                  <span class="label">操作人员：</span>
                  <span class="value">{{ scope.row.creator.userName }}</span>
                </div>
                <div class="bottom">
                  <span class="label">操作时间：</span>
                  <span class="value">{{ scope.row.createTime | formatDate("datetime") }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>
  </div>
</template>

<script>
import { wareHouseApi, recordApi } from "@/api"
import { getPathByTreeValue } from "vue2-element-admin-plugin"
import {markNonLeafNodes} from "@/utils/tree"
export default {
  name: "inventoryStatisticsManage",
  data() {
    return {
      dateRange2: [], // 操作时间
      dateRange: [], // 
      wareHouseId: [], // 仓库列表
      wareHouseData: [], // 仓库树 数据
      defaultProps: {
        checkStrictly: true,
        value: "wareHouseId",
        children: "children",
        label: "wareHouseName"
      },
      isUpdate: false, // 是否是编辑
      //搜索条件参数
      queryParams: {
        operateType: "", // 操作类型
        operateNo: "", // 操作单号
        goodsName: "", // 商品名称
        goodsSn: "", // 商品编号
        spuSn: "", // 单品编号
        wareHouseId: "", // 仓库id
        beginTime: "", // 生产日期开始时间
        endTime: "", // 生产日期结束时间
        beginCreateTime: "", // 操作开始时间
        endCreateTime: "", // 操作结束时间
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      selection: [], //选中的项
      loading: false,
      total: 0,
      open: false,
      // 表单参数
      baseForm: {
        entryType: "", // 
        entryStatus: "", // 
        remark: "" // 备注
      }

    }
  },
  watch: {
    open(val) {
      if (!val) {
        this.isUpdate = false
        this.baseForm = {
          entryType: "", // 
          entryStatus: "", // 
          remark: "" // 备注
        }
        this.$refs.entryDialog && this.$refs.entryDialog.resetForm()
      }
    }
  },
  async created() {
    await this.getWareHouseTree()
    const { query } = this.$route
    if (query.operateNo) {
      this.queryParams.operateNo = query.operateNo
    }
    //获取列表
    this.getList()
  },
  methods: {
    // 判断是否有对应权限
    hasPermission(operateType) {
      const obj = {
        "1": ["inventory:entry:list"],
        "2": ["inventory:out:list"],
        "3": ["inventory:move:list"],
        "4": ["inventory:check:list"]
      }
      return this.mixinHasPermi(obj[operateType])
    },
    // 前往查询单号
    handleDetail(data) {
      const { operateType, operateNo } = data
      const nameObj = {
        "1": "inventoryEntryManage",
        "2": "inventoryOutManage",
        "3": "inventoryMoveManage",
        "4": "inventoryCheckManage"
      }
      this.$router.push({
        name: nameObj[operateType],
        query: {
          operateNo
        }
      })
    },
    // 获取仓库名字
    getWareHouseName(val) {
      const list = getPathByTreeValue(this.wareHouseData, val, { targetField: "wareHouseId", childrenField: "children" }, true)
      return list[list.length - 1].labelArr.join("/")
    },
    // 获取仓库列表
    getWareHouseTree() {
      return wareHouseApi.getWareHouseTree().then((data) => {
        this.wareHouseData = markNonLeafNodes(data, this.mixinWareHouseIdList, {idField: "wareHouseId"})
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.dateRange2 = []
      this.wareHouseId = []
      this.mixinResetForm("queryForm")
      this.queryParams.operateNo = ""
      this.handleQuery()
    },
    /** 查询列表 */
    getList() {
      this.loading = true
      // 获取仓库id
      if (this.wareHouseId && this.wareHouseId.length > 0) {
        this.queryParams.wareHouseId = this.wareHouseId[this.wareHouseId.length - 1]
      } else {
        this.queryParams.wareHouseId = ""
      }

      const params = this.mixinAddDateRange(this.queryParams, this.dateRange2, "daterange", "CreateTime")
      recordApi
        .getList(this.mixinAddDateRange(params, this.dateRange, "date"))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    }
  }
}
</script>